<!--
  Fake Footer

  @since 2021-10-20
  @author mk.ko
-->

<template>
  <footer>
    <div class="page-footer-wrapper">
      <div class="page-footer">
        <div class="page-footer-content">
          <div class="page-footer-select col-xs-6 col-sm-6 col-md-6"
               :style="'left: 0'">
          </div>

          <div class="page-footer-option col-xs-6 col-sm-6 col-md-6">

          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'FakeFooter',
    components: {},
    props: {},
    data () {
      return {}
    },
    mounted () {},
    beforeDestroy () {},
    computed: {},
    destroyed () {},
    methods: {}
  }
</script>
